
import { defineComponent } from 'vue';
import { SocialProfile } from '@/models/Social/social-profile';
import Common from '@/components/Social/Profile/Common.vue';
import baseUrl from "@/api/base-url";

export default defineComponent({
    components: {
        PrzMobile: () => import('@/components/Social/Profile/Mobile.vue'),
        PrzDesktop: () => import('@/components/Social/Profile/Desktop.vue'),
    },
    props: {
        ...Common.props,
        profile: {
            type: Object,
            default: undefined
        },
        contentUrl: {
            type: String,
            default: baseUrl.getUrl('socialNetwork/content')
        },
        isDesktop:{
            type: Boolean,
            default: false
        },
        mention:{
            type: String,
            default: undefined
        },
        campaigns: {
            type: Object,
            default: undefined
        },
    },
    data(){
        let baseProfile: SocialProfile|undefined;
        return {
            baseProfile
        }
    },
    mounted(){
        this.baseProfile = this.getProfile();
    },
    computed:{
        socialProfile(): SocialProfile | undefined{
            return (this.baseProfile instanceof SocialProfile) ? this.baseProfile : undefined;
        }
    },
    methods: {
        getProfile(): SocialProfile | undefined {
            return SocialProfile.create(this.profile,this.contentUrl,!this.isDesktop);
        }
    }
});
